import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

import {AnalysisTemplateGraphQL} from './AnalysisTemplateTypes';
import {getInputTableApplyStates, InputTableApplyState} from './AnalysisTemplateUtil';

export interface TemplateApplyStateType {
  selectedTemplate: AnalysisTemplateGraphQL | null;
  inputTables: Array<InputTableApplyState>;
  selectedTemplateId: string | null;
}

/* @package */
export const TemplateApplyState = makeUseGlobalClientState<TemplateApplyStateType | null>(null);

/* @package */
export function getDefaultTemplateApplyState(): TemplateApplyStateType {
  return {
    selectedTemplate: null,
    inputTables: [],
    selectedTemplateId: null,
  };
}

export default function useAnalysisTemplateSelectorState(
  stateId: string
): [
  TemplateApplyStateType,
  (newState: TemplateApplyStateType) => void,
  (selectedTemplate: AnalysisTemplateGraphQL | null) => void,
  (selectedTemplateId: string | null) => void,
] {
  const [maybeTemplateApplyState, setTemplateApplyState] = TemplateApplyState.useGlobalClientState(stateId);
  const templateApplyState = maybeTemplateApplyState ?? getDefaultTemplateApplyState();

  function setSelectedTemplate(selectedTemplate: AnalysisTemplateGraphQL | null): void {
    if (selectedTemplate == null) {
      setTemplateApplyState(getDefaultTemplateApplyState());
    } else {
      setTemplateApplyState({
        ...templateApplyState,
        selectedTemplate,
        inputTables: getInputTableApplyStates(selectedTemplate, selectedTemplate.dataFrameVariables),
      });
    }
  }

  function setSelectedTemplateId(selectedTemplateId: string | null): void {
    setTemplateApplyState({
      ...templateApplyState,
      selectedTemplateId,
    });
  }

  return [templateApplyState, setTemplateApplyState, setSelectedTemplate, setSelectedTemplateId];
}
